export const fromQueryString = (string?: string | null): { [key: string]: string } => {
  if (!string) {
    return {}
  }
  if (string.charAt(0) === '?' || string.charAt(0) === '#') {
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    return fromQueryString(string.substr(1))
  }
  return string.split('&').reduce((hash, part) => {
    const [key, value] = part.split('=')
    // @ts-expect-error unchecked index access
    hash[key] = decodeURIComponent(value)
    return hash
  }, {})
}
